namespace Vit {
    const chToPx = 12;

    export class ObjectHelper {
        public static clone(obj: object): any {
            let cloneObj: any = {};

            for (const attr in obj) {
                if (typeof this[attr] === "object") {
                    cloneObj[attr] = ObjectHelper.clone(obj[attr]);
                } else {
                    cloneObj[attr] = obj[attr];
                }
            }

            return cloneObj;
        }

        // public static enumToArray(enumerator: object): ILookupKeyValue[] {
        //     return Object.keys(enumerator).map(key => <ILookupKeyValue>{key: enumerator[key], value: key});
        // }

        public static enumToArray(enumerator: object): ILookupKeyValue[] {
            let keys: Array<string> = Object.keys(enumerator),
                output: Array<ILookupKeyValue> = [];

            keys.forEach(key => {
                const id = +key;

                if (typeof id === "number" && !isNaN(id)) {
                    return;
                }

                output.push(<ILookupKeyValue>{
                    key: enumerator[key],
                    value: key,
                });
            });

            return output;
        }
    }

    export interface ISergenNode {
        id: number;
        name: string;
        children?: ISergenNode[];

        getProperties(): ISergenProperty[];
    }

    export abstract class SergenNodeBase implements ISergenNode {
        static counter: number = 1;
        static nodes: { [id: number]: ISergenNode; } = {};
        id: number;
        name: string;
        children?: ISergenNode[] = [];
        properties?: ISergenProperty[] = [];
        style: string = "";

        protected constructor(protected parent: SergenNodeBase, public nodeData: any, private readonly type: NodeType) {
            SergenNodeBase.Add(this);
        }

        static Add(node: ISergenNode) {
            node.id = SergenNodeBase.counter++;
            SergenNodeBase.nodes[node.id] = node;
        }

        static Reset() {
            SergenNodeBase.counter = 1;
            this.nodes = {};
        }

        static Get(id: number): ISergenNode {
            return this.nodes[id];
        }

        getProperties(): ISergenProperty[] {
            return this.properties;
        }

        setStyle() {
        }

        public moveUpChild(node1: SergenFieldNode) {
            var index1 = this.children.indexOf(node1);

            if (index1 <= 0) {
                return;
            }

            this.swappNodes(node1, -1);
        }

        public moveDownChild(node1: SergenFieldNode) {
            var index1 = this.children.indexOf(node1);

            if (index1 >= this.children.length - 1) {
                return;
            }

            this.swappNodes(node1, 1);
        }

        public RemoveNode(node: SergenNodeBase) {
            const nodeIndex = this.children.indexOf(node);

            if (nodeIndex === -1) {
                return;
            }

            this.children.splice(nodeIndex, 1);
        }

        public Remove() {
            if (!this.parent) {
                return;
            }

            this.parent.RemoveNode(this);
            this.parent.RemoveFromModel(this);
        }

        protected swappNodes(node1: SergenFieldNode, n: number) {
            var index1 = this.children.indexOf(node1);

            var index2 = index1 + n;
            var node2 = <SergenFieldNode>this.children[index2];


            var field1 = node1.getFieldInfo();
            var field2 = node2.getFieldInfo();
            var o = field1.Order;
            field1.Order = field2.Order;
            field2.Order = o;

            var childs = this.children;
            this.children = null;
            childs[index2] = node1;
            childs[index1] = node2;
            this.children = childs;

            var fields: Array<any> = this.nodeData.Fields;

            if (fields != null) {
                index1 = fields.indexOf(field1);
                index2 = fields.indexOf(field2);
                fields[index2] = field1;
                fields[index1] = field2;
            }
        }

        protected RemoveFromModel(node: SergenNodeBase) {
            throw "Not implemented!";
        }
    }

    export class SergernUILookupProvider {
        static Get(tableId?: string, uiType?: UIType): () => ILookupKeyValue[] {
            return () => {
                var lookups: ILookupKeyValue[] = [];
                var sergens: SergenUIInfo[] = tableId ? [SergenManager.current.getSergenInfo(tableId)] : SergenManager.current.SergenUIInfos;

                for (var sergen of sergens) {
                    if (sergen) {
                        for (var ui of sergen.UIModels) {
                            if (uiType == undefined || (uiType && ui.UIType == uiType)) {
                                lookups.push({
                                    key: ui,
                                    value: ui.Name,
                                });
                            }
                        }
                    }
                }

                return lookups;
            };
        }
    }

    export class SergenDataNode extends SergenNodeBase {
        constructor(private sergenInfo: SergenUIInfo) {
            super(null, sergenInfo, NodeType.Root);

            var defaultName = sergenInfo.DefaultForm.Name;
            this.properties.push(new SergenProperty("", sergenInfo, "Name"));
            this.properties.push(new SergenProperty("", sergenInfo, "Permission", EditorType.TextField));
            this.properties.push(new SergenProperty("", sergenInfo, "ModifyPermission", EditorType.TextField));
            this.properties.push(new SergenProperty("", sergenInfo, "DeletePermission", EditorType.TextField));

            this.properties.push(new SergenProperty("", sergenInfo, "InsertPermission", EditorType.TextField));
            this.properties.push(new SergenProperty("", sergenInfo, "UpdatePermission", EditorType.TextField));
            this.properties.push(new SergenProperty("", sergenInfo, "LookupPermission", EditorType.TextField));

            if (sergenInfo.LookupModels)
                for (var lookup of sergenInfo.LookupModels) {
                    this.children.push(new SergenLookupNode(this, sergenInfo, lookup));
                }

            for (const item of sergenInfo.UIModels) {
                this.children.push(SergenUINode.create(this, sergenInfo, item, item.Name != defaultName, this.getNameValidator(item)));
            }
        }

        get name(): string {
            return this.sergenInfo.Name;
        }

        public AddGridUI() {
            this.AddUI(this.sergenInfo.DefaultGrid);
        }

        public AddFormUI() {
            this.AddUI(this.sergenInfo.DefaultForm);
        }

        getNameValidator(ui: SergenUIModelInfo): (any) => string {
            return (val) => {
                if (this.IsValidName(ui, val)) {
                    return null;
                }

                return "Invalid Name!";
            };
        }

        public AddUI(ui: SergenUIModelInfo) {
            let newUI = <SergenUIModelInfo>ObjectHelper.clone(ui),
                i = 1,
                j = 1,
                k = 1;
            const name = newUI.Name;

            do {
                newUI.Name = `${name}_${i}`;
                i++;
            } while (!this.IsValidName(newUI));

            if (newUI.MenuNavigationLink && newUI.MenuNavigationLink.trim()) {
                do {
                    newUI.MenuNavigationLink = `${newUI.MenuNavigationLink.trim()}_${j}`;
                    j++;
                } while (!this.IsValidLink(newUI));
            }

            if (newUI.MenuNavigationAction && newUI.MenuNavigationAction.trim()) {
                do {
                    newUI.MenuNavigationAction = `${newUI.MenuNavigationAction.trim()}_${k}`;
                    k++;
                } while (!this.IsValidAction(newUI));
            }

            this.sergenInfo.UIModels.push(newUI);
            this.children.push(SergenUINode.create(this, this.sergenInfo, newUI, true, this.getNameValidator(newUI)));
        }

        protected RemoveFromModel(node: SergenUINode) {
            const nodeIndex = this.sergenInfo.UIModels.indexOf(node.uiModel);

            if (nodeIndex === -1) {
                return;
            }

            this.sergenInfo.UIModels.splice(nodeIndex, 1);
        }

        private IsValidLink(ui: SergenUIModelInfo): boolean {
            if (!ui.MenuNavigationLink.trim()) {
                return true;
            }

            const duplicate = (this.sergenInfo.UIModels as any).find((item) => item !== ui && item.MenuNavigationLink === ui.MenuNavigationLink);

            if (duplicate) {
                return false;
            }

            return true;
        }

        public IsValidAction(ui: SergenUIModelInfo): boolean {
            if (!ui.MenuNavigationAction.trim()) {
                return true;
            }

            const duplicate = (this.sergenInfo.UIModels as any).find((item) => item !== ui && item.MenuNavigationAction === ui.MenuNavigationAction);

            if (duplicate) {
                return false;
            }

            return true;
        }

        private IsValidName(ui: SergenUIModelInfo, name?: string): boolean {
            name = name || ui.Name;

            for (const item of this.sergenInfo.UIModels) {
                if (item !== ui && item.Name === name) {
                    return false;
                }
            }

            return true;
        }
    }

    export class SergenLookupNode extends SergenNodeBase {
        public constructor(protected parentNode: SergenDataNode, protected sergenInfo: SergenUIInfo, public lookupModel: SergenLookupModelInfo) {
            super(parentNode, sergenInfo, NodeType.Lookup);

            this.properties.push(new SergenProperty("", lookupModel, "Name", EditorType.TextField));
            this.properties.push(new SergenProperty("", lookupModel, "LookupDisplayColumn", EditorType.LookupField, null, null, SergenManager.current.GetColumns()));

            var lookupDisplayExpressionProperty = new SergenProperty("", lookupModel, "LookupDisplayExpression", EditorType.TextField);

            this.properties.push(lookupDisplayExpressionProperty);

            var SetServerSide = () => {
                for (var column of lookupModel.Columns) {
                    this.children.push(new SergenGridFieldNode(this, column));
                }
            };

            var SetClientSide = () => {
                this.children = [];
            };

            this.properties.push(new SergenProperty("", lookupModel, "LookupType", EditorType.LookupField, false, null, ObjectHelper.enumToArray(LookupTypeEnum), null, (newValue, oldValue) => {
                if (newValue === oldValue) {
                    return;
                }

                switch (<LookupTypeEnum>newValue) {
                    case LookupTypeEnum.ClientSide:
                        SetClientSide();

                        break;
                    case LookupTypeEnum.ServerSide:
                        SetServerSide();

                        break
                }
            }));

            switch (lookupModel.LookupType) {
                case LookupTypeEnum.ServerSide:
                    SetServerSide();

                    break;
                case LookupTypeEnum.ClientSide:
                    SetClientSide();

                    break;
            }
        }

        get name(): string {
            return `${this.lookupModel.Name}${Globals.LookupEditorName}`;
        }

        set name(value: string) {
            this.lookupModel.Name = value;
        }
    }

    export abstract class SergenUINode extends SergenNodeBase {
        protected constructor(protected parentNode: SergenDataNode, protected sergenInfo: SergenUIInfo, public uiModel: SergenUIModelInfo, public canDelete: boolean) {
            super(parentNode, sergenInfo, NodeType.UI);

            this.properties.push(new SergenProperty("", uiModel, "MenuNavigationLink", EditorType.TextField));
            this.properties.push(new SergenProperty("", uiModel, "MenuNavigationIcon", EditorType.TextField));
            this.properties.push(new SergenProperty("", uiModel, "MenuNavigationAction", EditorType.TextField));
        }

        static create(parent: SergenDataNode, sergenInfo: SergenUIInfo, uiModel: SergenUIModelInfo, canDelete: boolean, nameValidator: (any) => string): SergenUINode {
            switch (uiModel.UIType) {
                case UIType.GridUI:
                    return new SergenGridUINode(parent, sergenInfo, uiModel, canDelete, nameValidator);

                case UIType.FormUI:
                    return new SergenFormUINode(parent, sergenInfo, uiModel, canDelete, nameValidator);
            }
        }

        getUIModel(): SergenUIModelInfo {
            return this.uiModel;
        }

        protected RemoveFromModel(node: SergenNodeBase) {
            var nodeIndex = this.sergenInfo.UIModels.indexOf(node.nodeData);
            this.sergenInfo.UIModels.splice(nodeIndex, 1);
        }

        private clone(): void {
            this.parentNode.AddUI(this.uiModel);
        }

        private AddField(): void {
            const order = this.uiModel.Fields[this.uiModel.Fields.length - 1].Order + 1,
                fieldName = `Field_${order + 1}`;
            let field: any,
                fieldNode: any;

            switch (this.uiModel.UIType) {
                case UIType.GridUI:
                    field = {
                        FieldType: FieldType.String,
                        Visible: Visibility.Visible,
                        Name: `Grid${fieldName}`,
                        Order: order,
                        DisplayName: `Grid${fieldName}`,
                        Ignore: false,
                        IgnoreName: true,
                        AlignRight: true,
                        IsDetail: false,

                        EditLink: true,
                        Hidden: false,
                        Sortable: true,
                        Resizable: true,
                        AllowHide: false,
                        QuickFilter: false,
                        NotFilterable: false,
                    };
                    fieldNode = new SergenGridFieldNode(this, <SergenGridFieldInfo>field);

                    break;
                case UIType.FormUI:
                    field = {
                        FieldType: FieldType.String,
                        Visible: Visibility.Visible,
                        Name: `Form${fieldName}`,
                        Order: order,
                        DisplayName: `Form${fieldName}`,
                        Ignore: false,
                        IgnoreName: true,
                        AlignRight: false,
                        IsDetail: false,

                        Required: false,
                        InsertableAttrib: true,
                        UpdatableAttrib: true,
                        HideOnInsert: false,
                        HideOnUpdate: false,
                        OneWay: false,
                    };
                    fieldNode = new SergenFormFieldNode(this, <SergenFormFieldInfo>field);

                    break;
            }

            this.uiModel.Fields.push(field);
            this.children.push(fieldNode);
        }
    }

    export class SergenGridUINode extends SergenUINode {
        constructor(parent: SergenDataNode, sergenInfo: SergenUIInfo, uiModel: SergenUIModelInfo, canDelete: boolean, nameValidator: (any) => string) {
            super(parent, sergenInfo, uiModel, canDelete);

            this.properties.push(new SergenProperty("", uiModel, "Name", canDelete ? EditorType.TextField : null, null, null, null, nameValidator));
            this.properties.push(new SergenProperty("", uiModel, "DialogType", EditorType.LookupField, true, null, SergernUILookupProvider.Get(this.sergenInfo.Name, UIType.FormUI)));
            this.properties.push(new SergenProperty("", uiModel, "NewDialogType", EditorType.LookupField, true, null, SergernUILookupProvider.Get(this.sergenInfo.Name, UIType.FormUI)));
            this.properties.push(new SergenProperty("", uiModel, "DeleteButtonInGrid", EditorType.CheckboxField));

            var i = 0;

            for (const item of uiModel.Fields) {
                item.Order = i++;
                this.children.push(new SergenGridFieldNode(this, <SergenGridFieldInfo>item));
            }
        }

        get name(): string {
            return `${this.uiModel.Name}Grid`;
        }

        set name(value: string) {
            this.uiModel.Name = value;
        }

        public Swapp(id1: number, id2: number) {
            var node1 = <SergenFieldNode>SergenNodeBase.Get(id1);
            var node2 = <SergenFieldNode>SergenNodeBase.Get(id2);
            var index1 = this.children.indexOf(node1);
            var index2 = this.children.indexOf(node2);

            if (index1 > -1 && index2 > -1) {
                var field1 = node1.getFieldInfo();
                var field2 = node2.getFieldInfo();
                var o = field1.Order;
                field1.Order = field2.Order;
                field2.Order = o;

                this.children[index2] = node1;
                this.children[index1] = node2;
            }
        }
    }

    export class SergenFieldNode extends SergenNodeBase {
        constructor(parent: SergenNodeBase, protected uiField: SergenFieldInfo) {
            super(parent, uiField, NodeType.UIField);

            this.setStyle();
        }

        get name(): string {
            return this.uiField.Name;
        }

        set name(value: string) {
            this.uiField.Name = value;
        }

        getFieldInfo(): SergenFieldInfo {
            return this.uiField;
        }

        public moveUp() {
            this.parent.moveUpChild(this);
        }

        public moveDown() {
            this.parent.moveDownChild(this);
        }

        setStyle() {
            let classes = "";

            switch (this.uiField.Visible) {
                case Visibility.None:
                case Visibility.Hidden:
                    classes = "grey--text lighten-3 line-through";

                    break;
            }

            this.style = classes;
        }
    }

    export class SergenGridFieldNode extends SergenFieldNode {
        static readonly minWidth: number = 60;

        constructor(parent: SergenNodeBase, gridField: SergenGridFieldInfo) {
            super(parent, gridField);

            const self = this;

            if (gridField.JoinInfo) {
                gridField.Source = `From${gridField.JoinInfo.Name}`;
            } else {
                gridField.Source = "Own";
            }


            if (!gridField.IgnoreName) {
                this.properties.push(new SergenProperty("", gridField, "Name"));

                switch (gridField.DataType) {
                    case "Int16":
                    case "Int32":
                        this.properties.push(new SergenProperty("", gridField, "FieldType", EditorType.LookupField,
                            false, null, SergenManager.current.GetEnums([{
                                key: gridField.DataType,
                                value: gridField.DataType,
                            }])));

                        break;
                    default:
                        this.properties.push(new SergenProperty("", gridField, "FieldType"));

                        break;
                }
            } else {
                this.properties.push(new SergenProperty("", gridField, "Name", EditorType.TextField));
                this.properties.push(new SergenProperty("", gridField, "FieldType", EditorType.LookupField, false, null,
                    SergenManager.current.GetEnums(ObjectHelper.enumToArray(FieldType))));

                this.properties.push(new SergenProperty("", gridField, "Expression", EditorType.TextField, true));
            }

            // this.properties.push(new SergenProperty("", gridField, "Source"));
            this.properties.push(new SergenProperty("", gridField, "EditLink", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", gridField, "AlignRight", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", gridField, "AllowHide", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", gridField, "GridFormatter", EditorType.LookupField, false, null,
                this.GetAllowedFormatter(gridField)));
            this.properties.push(new SergenProperty("", gridField, "Hidden", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", gridField, "Ignore", EditorType.CheckboxField));
            // this.properties.push(new SergenProperty("", gridField, "IgnoreName", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", gridField, "NotFilterable", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", gridField, "QuickFilter", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", gridField, "Resizable", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", gridField, "Sortable", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", gridField, "DisplayName", EditorType.TextField));
            this.properties.push(new SergenProperty("", gridField, "Width", EditorType.NumberField, true,
                ((gridField.Name.length * chToPx) > SergenGridFieldNode.minWidth) ? gridField.Name.length * chToPx : SergenGridFieldNode.minWidth));

            if (gridField.FieldType === FieldType.TimeStamp) {
                this.properties.push(new SergenProperty("", gridField, "Visible", null, true, null, ObjectHelper.enumToArray(Visibility)));
            } else {
                this.properties.push(new SergenProperty("", gridField, "Visible", EditorType.LookupField, false, null, ObjectHelper.enumToArray(Visibility), () => {
                    this.setStyle();

                    return null;
                }));
            }

            if (gridField.Fields) {
                for (var subField of gridField.Fields) {
                    this.children.push(new SergenGridFieldNode(this, <SergenGridFieldInfo>subField));
                }
            }
        }

        protected GetAllowedFormatter(GridField: SergenGridFieldInfo): ILookupKeyValue[] {
            switch (GridField.FieldType) {
                case FieldType.Int16:
                case FieldType.Int32:
                case FieldType.Int64:
                case FieldType.Decimal:
                    return [{
                        key: GridFormatter.NumberFormatter,
                        value: GridFormatter[GridFormatter.NumberFormatter],
                    }, {
                        key: GridFormatter.EnumFormatter,
                        value: GridFormatter[GridFormatter.EnumFormatter],
                    },];

                case FieldType.String:
                    return [{
                        key: GridFormatter.UrlFormatter,
                        value: GridFormatter[GridFormatter.UrlFormatter],
                    }, {
                        key: GridFormatter.FileDownloadFormatter,
                        value: GridFormatter[GridFormatter.FileDownloadFormatter],
                    },];

                case FieldType.DateTime:
                    return [{
                        key: GridFormatter.DateFormatter,
                        value: GridFormatter[GridFormatter.DateFormatter],
                    }, {
                        key: GridFormatter.DateTimeFormatter,
                        value: GridFormatter[GridFormatter.DateTimeFormatter],
                    }];

                /*case FieldType.:
                    return [{
                        key: GridFormatter.DateFormatter,
                        value: "DateFormatter",
                    }];*/
                case FieldType.Boolean:
                    return [{
                        key: GridFormatter.DateFormatter,
                        value: GridFormatter[GridFormatter.DateFormatter],
                    }];

                default:
                    return ObjectHelper.enumToArray(GridFormatter);
            }
        }
    }

    export class SergenFormInfo {
        methodPostfix: string;

        constructor(protected sergenInfo: SergenUIInfo, protected uiModel: SergenUIModelInfo, canDelete: boolean) {
            this.methodPostfix = (canDelete) ? `_${uiModel.Name}` : "";
        }

        get CreateFormId(): string {
            return `${SergenManager.current.connection}.${this.uiModel.Name}:Services/${SergenManager.current.connection}/${SergenManager.current.TableName}/Create${this.methodPostfix}`;
        }

        get UpdateFormId(): string {
            return `${SergenManager.current.connection}.${this.uiModel.Name}:Services/${SergenManager.current.connection}/${SergenManager.current.TableName}/Update${this.methodPostfix}`;
        }
    }

    export class SergenFormUINode extends SergenUINode {
        constructor(parent: SergenDataNode, sergenInfo: SergenUIInfo, uiModel: SergenUIModelInfo, canDelete: boolean, nameValidator: (any) => string) {
            super(parent, sergenInfo, uiModel, canDelete);
            this.properties.push(new SergenProperty("", uiModel, "Name", (canDelete) ? EditorType.TextField : null, null, null, null, nameValidator));

            var a = new SergenFormInfo(this.sergenInfo, this.uiModel, canDelete);
            this.properties.push(new SergenProperty("", a, "CreateFormId", null, null, null, null, null));
            this.properties.push(new SergenProperty("", a, "UpdateFormId", null, null, null, null, null));

            let i = 0;

            for (const item of uiModel.Fields) {
                item.Order = i++;
                this.children.push(new SergenFormFieldNode(this, <SergenFormFieldInfo>item));
            }
        }

        get name(): string {
            return `${this.uiModel.Name}Form`;
        }

        set name(value: string) {
            this.uiModel.Name = value;
        }
    }

    export class SergenFormFieldNode extends SergenFieldNode {
        constructor(parent: SergenNodeBase, protected formField: SergenFormFieldInfo) {
            super(parent, formField);

            const formFieldItems: Array<ISergenNode> = parent.children;
            const self = this;
            const IsVisible = (): boolean => formField.Visible === Visibility.Visible;
            const setLookupRelated = (): void => {
                if ((!formField.EditorType || !(new RegExp(/LookupEditor$/).test(formField.EditorType.trim()))) || FormCascadeFromProperty) {
                    return;
                }

                FormCascadeFromProperty = new SergenProperty("", formField, "CascadeFrom", EditorType.LookupField, false, null, function () {
                    var lookupValues = [];

                    formFieldItems.forEach(function (currentValue) {
                        if (formField.Name === currentValue.name) {
                            return;
                        }

                        lookupValues.push({
                            key: currentValue.name,
                            value: currentValue.name,
                        });
                    });

                    return lookupValues;
                });
                this.properties.push(FormCascadeFromProperty);

                /* Set not mapped field based on */
                if (!formField.IgnoreName || RowTypeProperty) {
                    return;
                }

                RowTypeProperty = new SergenProperty("", formField, "RowType", EditorType.TextField, false, null);
                this.properties.push(RowTypeProperty);
            };
            const getEditorProperty = function (fieldType: string): ISergenProperty {
                return new SergenProperty("", formField, "EditorType", EditorType.LookupField, false, null, self.GetAllowedEditorTypes(fieldType), (val) => {
                    if (!IsVisible()) {
                        return null;
                    }

                    setLookupRelated();

                    return null;
                });
            };

            let gridEditorTypeProperty: SergenProperty = null,
                FormCascadeFromProperty: SergenProperty = null,
                RowTypeProperty: SergenProperty = null;

            if (!formField.IgnoreName) {
                this.properties.push(new SergenProperty("", formField, "Name"));

                switch (formField.DataType) {
                    case "Int16":
                    case "Int32":
                        this.properties.push(new SergenProperty("", formField, "FieldType", EditorType.LookupField, false, null,
                            SergenManager.current.GetEnums([{
                                key: formField.DataType,
                                value: formField.DataType,
                            },])));

                        break;
                    default:
                        this.properties.push(new SergenProperty("", formField, "FieldType"));

                        break;
                }

                this.properties.push(new SergenProperty("", formField, "DisplayName"));
            } else {
                this.properties.push(new SergenProperty("", formField, "Name", EditorType.TextField));
                this.properties.push(new SergenProperty("", formField, "FieldType", EditorType.LookupField, false, null,
                    SergenManager.current.GetEnums(ObjectHelper.enumToArray(FieldType)), null, function (newValue, oldValue) {
                        if (newValue === oldValue) {
                            return;
                        }

                        const properties = (self.properties as any),
                            propIndex = properties.findIndex((currentValue) => currentValue.propertyName === "Editor");

                        properties.splice(propIndex, 1, getEditorProperty(newValue));
                    }));
                this.properties.push(new SergenProperty("", formField, "DisplayName", EditorType.TextField));
            }

            this.properties.push(new SergenProperty("", formField, "AlignRight", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", formField, "HideOnInsert", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", formField, "HideOnUpdate", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", formField, "Ignore", EditorType.CheckboxField));
            // this.properties.push(new SergenProperty("", formField, "IgnoreName", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", formField, "LabelWidth", EditorType.NumberField, true));
            this.properties.push(new SergenProperty("", formField, "MaxLength", EditorType.NumberField, true));
            this.properties.push(new SergenProperty("", formField, "OneWay", EditorType.CheckboxField));

            this.properties.push(new SergenProperty("", formField, "Placeholder", EditorType.TextField));
            this.properties.push(new SergenProperty("", formField, "Required", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", formField, "UpdatableAttrib", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", formField, "InsertableAttrib", EditorType.CheckboxField));
            this.properties.push(new SergenProperty("", formField, "Width", EditorType.NumberField, true));
            this.properties.push(new SergenProperty("", formField, "Tab", EditorType.TextField));
            this.properties.push(new SergenProperty("", formField, "Category", EditorType.TextField));
            this.properties.push(new SergenProperty("", formField, "PropWidth", EditorType.LookupField, false, null,
                ObjectHelper.enumToArray(PropWidth)));

            const setCascadeFrom = (): void => {
                if (formField.Editor !== FormEditorType.LookupEditor || FormCascadeFromProperty) {
                    return;
                }

                FormCascadeFromProperty = new SergenProperty("", formField, "CascadeFrom", EditorType.LookupField, false,
                    null, () => {
                        const lookupValues = [];

                        formFieldItems.forEach((currentValue) => {
                            if (formField.Name === currentValue.name) {
                                return;
                            }

                            lookupValues.push(<ILookupKeyValue>{
                                key: currentValue.name,
                                value: currentValue.name,
                            });
                        });

                        return lookupValues;
                    });
                this.properties.push(FormCascadeFromProperty);
            };

            if (formField.FieldType === FieldType.TimeStamp) {
                this.properties.push(new SergenProperty("", formField, "Visible", null, true, null, ObjectHelper.enumToArray(Visibility)));
            } else {
                this.properties.push(new SergenProperty("", formField, "Visible", EditorType.LookupField, false, null,
                    ObjectHelper.enumToArray(Visibility), (val) => {
                        this.setStyle();

                        if (!IsVisible()) {
                            this.resetEditorType();

                            return null;
                        }

                        setLookupRelated();

                        if (formField.IsDetail) {
                            SergenManager.current.loadDetailTable(formField.DetailTableName, () => {
                                if (!gridEditorTypeProperty) {
                                    gridEditorTypeProperty = new SergenProperty("", formField, "GridEditorType",
                                        EditorType.LookupField, false, null, SergernUILookupProvider.Get(formField.DetailTableName, UIType.GridUI));
                                    this.properties.push(gridEditorTypeProperty);
                                }
                            });
                        }

                        return null;
                    }));
            }

            // this.properties.push(new SergenProperty("", formField, "Editor", EditorType.LookupField, false, null, this.GetAllowedEditors(formField)));
            this.properties.push(getEditorProperty(formField.FieldType));
            setLookupRelated();

            if (IsVisible()) {
                if (formField.IsDetail) {
                    SergenManager.current.loadDetailTable(formField.DetailTableName, () => {
                        if (!gridEditorTypeProperty) {
                            gridEditorTypeProperty = new SergenProperty("", formField, "GridEditorType",
                                EditorType.LookupField, false, null, SergernUILookupProvider.Get(formField.DetailTableName, UIType.GridUI));
                            this.properties.push(gridEditorTypeProperty);
                        }
                    });
                }
            }
        }

        /*protected GetAllowedEditors(fieldType: string): ILookupKeyValue[] {
            switch (fieldType) {
                case "String":
                    return [{
                        key: FormEditorType.StringEditor,
                        value: "StringEditor",
                    }, {
                        key: FormEditorType.TextAreaEditor,
                        value: "TextAreaEditor",
                    }, {
                        key: FormEditorType.EmailEditor,
                        value: "EmailEditor",
                    }, {
                        key: FormEditorType.EmailAddressEditor,
                        value: "EmailAddressEditor",
                    }, {
                        key: FormEditorType.PasswordEditor,
                        value: "PasswordEditor",
                    }, {
                        key: FormEditorType.URLEditor,
                        value: "URLEditor",
                    }, {
                        key: FormEditorType.TimeEditor,
                        value: "TimeEditor",
                    }, {
                        key: FormEditorType.RadioButtonEditor,
                        value: "RadioButtonEditor",
                    }, {
                        key: FormEditorType.FileUploadEditor,
                        value: "FileUploadEditor",
                    }, {
                        key: FormEditorType.MultipleFileUploadEditor,
                        value: "MultipleFileUploadEditor",
                    }, {
                        key: FormEditorType.ImageUploadEditor,
                        value: "ImageUploadEditor",
                    }, {
                        key: FormEditorType.MultipleImageUploadEditor,
                        value: "MultipleImageUploadEditor",
                    }, {
                        key: FormEditorType.MapEditor,
                        value: "MapEditor",
                    },];

                case "Int16":
                case "Int32":
                case "Int64":
                    return [{
                        key: FormEditorType.IntegerEditor,
                        value: "IntegerEditor",
                    }, /!* {
                        key: FormEditorType.DateYearEditor,
                        value: "DateYearEditor",
                    }, *!/];

                case "Boolean":
                    return [{
                        key: FormEditorType.BooleanEditor,
                        value: "BooleanEditor",
                    },];

                case "Decimal":
                case "Double":
                    return [{
                        key: FormEditorType.DecimalEditor,
                        value: "DecimalEditor",
                    },];

                case "DateTime":
                    return [{
                        key: FormEditorType.DateEditor,
                        value: "DateEditor",
                    }, {
                        key: FormEditorType.DateTimeEditor,
                        value: "DateTimeEditor",
                    }];

                /!*case "Date":
                    return [{
                        key: 10,
                        value: "DateEditor",
                    }];*!/
                case "Time":
                    return [{
                        key: FormEditorType.TimeEditor,
                        value: "TimeEditor",
                    }];

                case "Guid":
                    return [{
                        key: FormEditorType.LookupEditor,
                        value: "LookupEditor",
                    },];

                default:
                    return ObjectHelper.enumToArray(FormEditorType);
            }
        }*/

        protected GetAllowedEditorTypes(fieldType: string): ILookupKeyValue[] {
            let items: ILookupKeyValue[] = [];

            switch (fieldType) {
                case "String":
                    items = [{
                        key: FormEditorType[FormEditorType.StringEditor],
                        value: FormEditorType[FormEditorType.StringEditor],
                    }, {
                        key: FormEditorType[FormEditorType.TextAreaEditor],
                        value: FormEditorType[FormEditorType.TextAreaEditor],
                    }, {
                        key: FormEditorType[FormEditorType.EmailEditor],
                        value: FormEditorType[FormEditorType.EmailEditor],
                    }, {
                        key: FormEditorType[FormEditorType.EmailAddressEditor],
                        value: FormEditorType[FormEditorType.EmailAddressEditor],
                    }, {
                        key: FormEditorType[FormEditorType.PasswordEditor],
                        value: FormEditorType[FormEditorType.PasswordEditor],
                    }, {
                        key: FormEditorType[FormEditorType.URLEditor],
                        value: FormEditorType[FormEditorType.URLEditor],
                    }, {
                        key: FormEditorType[FormEditorType.TimeEditor],
                        value: FormEditorType[FormEditorType.TimeEditor],
                    }, {
                        key: FormEditorType[FormEditorType.RadioButtonEditor],
                        value: FormEditorType[FormEditorType.RadioButtonEditor],
                    }, {
                        key: FormEditorType[FormEditorType.FileUploadEditor],
                        value: FormEditorType[FormEditorType.FileUploadEditor],
                    }, {
                        key: FormEditorType[FormEditorType.MultipleFileUploadEditor],
                        value: FormEditorType[FormEditorType.MultipleFileUploadEditor],
                    }, {
                        key: FormEditorType[FormEditorType.ImageUploadEditor],
                        value: FormEditorType[FormEditorType.ImageUploadEditor],
                    }, {
                        key: FormEditorType[FormEditorType.MultipleImageUploadEditor],
                        value: FormEditorType[FormEditorType.MultipleImageUploadEditor],
                    }, {
                        key: FormEditorType[FormEditorType.MapEditor],
                        value: FormEditorType[FormEditorType.MapEditor],
                    },];

                    break;
                case "Int16":
                case "Int32":
                case "Int64":
                    items = [{
                        key: FormEditorType[FormEditorType.IntegerEditor],
                        value: FormEditorType[FormEditorType.IntegerEditor],
                    }, /* {
                        key: FormEditorType.DateYearEditor,
                        value: "DateYearEditor",
                    }, */];

                    break;
                case "Boolean":
                    items = [{
                        key: FormEditorType[FormEditorType.BooleanEditor],
                        value: FormEditorType[FormEditorType.BooleanEditor],
                    },];

                    break;
                case "Decimal":
                case "Double":
                    items = [{
                        key: FormEditorType[FormEditorType.DecimalEditor],
                        value: FormEditorType[FormEditorType.DecimalEditor],
                    },];

                    break;
                case "DateTime":
                    items = [{
                        key: FormEditorType[FormEditorType.DateEditor],
                        value: FormEditorType[FormEditorType.DateEditor],
                    }, {
                        key: FormEditorType[FormEditorType.DateTimeEditor],
                        value: FormEditorType[FormEditorType.DateTimeEditor],
                    },];

                    break;
                /* case "Date":
                    return [{
                        key: 10,
                        value: "DateEditor",
                    }]; */
                case "Time":
                    items = [{
                        key: FormEditorType[FormEditorType.TimeEditor],
                        value: FormEditorType[FormEditorType.TimeEditor],
                    },];

                    break;
                case "Guid":
                    /*items = [{
                       key: FormEditorType[FormEditorType.LookupEditor],
                       value: "LookupEditor",
                    },];*/

                    break;
                case "Detail":
                    items = [{
                        key: FormEditorType[FormEditorType.GridEditor],
                        value: FormEditorType[FormEditorType.GridEditor],
                    },];

                    break;
                default:
                    return ObjectHelper.enumToArray(FormEditorType);
            }

            const lookups = (this.formField.PKSchema != null && this.formField.PKTable != null) ?
                SergenManager.current.GetLookups(this.formField.PKSchema, this.formField.PKTable) :
                SergenManager.current.GetLookupsByDataType(fieldType);

            for (const item of lookups) {
                items.push({
                    key: item,
                    value: item,
                });
            }

            return items;
        }

        private resetEditorType() {
            this.nodeData.EditorType = null;
        }
    }
}